<app-cargando *ngIf="cargando"></app-cargando>
<div class="card">
  <div class="card-header">
    <h3 class="card-title" style="margin-right: 10px">Oportunidad ID: 4269</h3>
    <a href="/Oportunidad/InformePresupuesto?ID=4269" target="_blank" style="color: #91CA41;">
      <i class="fas fa-sign-in-alt"></i
    ></a>
    <br />
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-8 order-2 order-md-1">
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <div class="info-box-content">
                <span class="info-box-text">ÚItima actualización</span>
                <span class="info-box-number float-right"> {{data.UpdateDate | date: 'dd/MM/yyyy'}} </span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
              <div class="info-box-content" style="padding: 0px;">



                <div class="btn btn-primary" type="button" (click)="verMonto()" style="position: absolute;top: 0px;right: 0px;">
                  <i class="fa-solid fa-pencil"></i>
                </div>


                <span class="info-box-text">Monto ponderado </span>
                <span class="info-box-number float-right"> {{data.MaxSumLoc | iNDCLP}} </span>

                <div *ngIf="changeMonto">
                  <div class="progress">
                    <div class="progress-bar" style="width: 100%"></div>
                  </div>

                  <span class="info-box-text">Cambiar monto: </span>
                  <input (change)="actualizarDatos('el monto ponderado')" [(ngModel)]="data.MaxSumLoc" type="number" name="" id="">
                </div>



              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">

              <div class="info-box-content">

                <div class="btn btn-primary" type="button" (click)="verFecha()" style="position: absolute;top: 0px;right: 0px;">
                  <i class="fa-solid fa-pencil"></i>
                </div>

                <span class="info-box-text">Cierre previsto: </span>
                <span class="info-box-number float-right"> {{data.PredDate | date: 'dd/MM/yyyy'}} </span>

                <div *ngIf="changeFecha">
                  <div class="progress">
                    <div class="progress-bar" style="width: 100%"></div>
                  </div>

                  <span class="info-box-text">Cambiar fecha: </span>
                  <input (change)="actualizarDatos('la Fecha de cierre previsto')" type="date" name="" [(ngModel)]="CIERRE_PREVISTO">

                </div>

              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <div class="col-md-3 col-sm-6 col-12">

            
            <div class="info-box bg-primary">

              
              
              <div class="info-box-content">

                <select (change)="actualizaOportunidadFast()" class="info-box-text" style="white-space: normal;width: 150px;background: #90c940;border: none;" [(ngModel)]="data.OPR1[data.OPR1.length - 1].Step_Id">
                  <option *ngFor="let item of Etapas" [value]="item.StepId">{{item.Descript}}</option>
                </select>
                
                
                <div *ngFor="let item of Etapas">
                  <div *ngIf="data.OPR1[data.OPR1.length - 1].Step_Id == item.StepId">

                    <span class="info-box-number float-right">{{item.CloPrcnt}} %</span>

                    <div class="progress">
                      <div class="progress-bar" [style]="'width: '+item.CloPrcnt+'%'"></div>
                    </div>
                    <span class="progress-description"> </span>

                  </div>
                </div>

              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12">
            <div class="card card-tabs">
              <div class="card-header p-0 pt-1">
                <ul
                  class="nav nav-tabs"
                  id="custom-tabs-one-tab"
                  role="tablist"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link active colorverde"
                      id="custom-tabs-one-home-tab"
                      data-toggle="pill"
                      href="#custom-tabs-one-home"
                      role="tab"
                      aria-controls="custom-tabs-one-home"
                      aria-selected="true"
                      >Agregar actividad</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link colorverde"
                      id="custom-tabs-one-messages-tab"
                      data-toggle="pill"
                      href="#EtapasOportunidad"
                      role="tab"
                      aria-controls="custom-tabs-one-messages"
                      aria-selected="false"
                      >Etapas</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link colorverde"
                      id="custom-tabs-one-LOG_SAP-tab"
                      data-toggle="pill"
                      href="#INT_historico"
                      role="tab"
                      aria-controls="custom-tabs-one-settings"
                      aria-selected="false"
                      >Log Intranet</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link colorverde"
                      id="custom-tabs-one-profile-tab"
                      data-toggle="pill"
                      href="#LOG_SAP"
                      role="tab"
                      aria-controls="custom-tabs-one-profile"
                      aria-selected="false"
                      >Log SAP</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link colorverde"
                      id="custom-tabs-one-resumen-tab"
                      data-toggle="pill"
                      href="#resumen"
                      role="tab"
                      aria-controls="custom-tabs-one-resumen"
                      aria-selected="false"
                      >Resumen</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link colorverde"
                      id="custom-tabs-one-Items-tab"
                      data-toggle="pill"
                      href="#Items"
                      role="tab"
                      aria-controls="custom-tabs-one-Items"
                      aria-selected="false"
                      >Articulos</a
                    >
                  </li>
                </ul>
              </div>
              <div class="card-body">
                <div class="tab-content" id="custom-tabs-one-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="custom-tabs-one-home"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-home-tab"
                  >
                    <div class="form-group col-12">
                      <div class="row">

                        <div class="col-sm-4">
                          <label>Actividad</label>
                          <select
                            class="form-control select2"
                            id="ActividadAct"
                            name="ActividadAct"
                            [(ngModel)]="ActividadNueva.Action"
                          >
                            <option value="" disabled>Ingrese actividad</option>
                            <option value="C">Llamada telefonica</option>
                            <option value="E">Nota</option>
                            <option value="M">Reunion</option>
                            <option value="N">Otros</option>
                            <option value="P">Campaña</option>
                            <option value="T">Tarea</option>
                          </select>
                        </div>
                        <div class="col-sm-4">
                          <label>Tipo</label>
                          <select
                            class="form-control select2"
                            id="TipoActividad"
                            name="TipoActividad"
                            [(ngModel)]="ActividadNueva.CntctType"
                          >
                            <option value="" disabled>Ingrese tipo</option>
                            <option *ngFor="let item of ActividadesTipos" value="{{item.Code}}">{{item.Name}}</option>
                          </select>
                        </div>
                        <div class="col-sm-4">
                          <label>Asunto</label>
                          <select
                            class="form-control select2"
                            id="AsuntosActividad"
                            name="AsuntosActividad"
                            [(ngModel)]="ActividadNueva.CntctSbjct"
                            >
                          <option value="-1" disabled>Ingrese Asunto</option>
                          <option *ngFor="let item of ActividadesAsuntos" value="{{item.Code}}">{{item.Name}}</option>
                        </select>
                        </div>
                      </div>
                      <div class="form-control" style="height: auto;">
                        <input
                          type="text"
                          name="mensaje"
                          id="ACTMSG"
                          class="col-12"
                          autocomplete="off"
                          style="background: #3F474E;border-radius: 5px;border: 1px solid #91CA41;color: white;"
                          placeholder="Escriba contenido..."
                          [(ngModel)]="ActividadNueva.Notes"
                          [(ngModel)]="ActividadNueva.Details"
                        />
                      </div>

                      <div class="form-control" style="height: auto;">
                        <button
                          (click)="ActividadNuevaFunction()"
                          class="btn btn-outline-primary">Crear Actividad</button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="EtapasOportunidad"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-messages-tab"
                  >

                  <div class="form-group col-12 table-active mb-2 mt-2">
                    <div class="row">

                      <div class="form-group col-6">
                        <label>Etapa</label>
                        <br />
                        <select [(ngModel)]="nuevaEtapa.Step_Id"
                          id="oost-steps"
                          class="form-control select2-hidden-accessible"
                          style="width: 100%"
                          data-select2-id="oost-steps"
                          tabindex="-1"
                          aria-hidden="true"
                        >
                          <option *ngFor="let etapa of Etapas" [value]="etapa.StepId">
                            {{etapa.Descript}}
                          </option>
                        </select>

                      </div>
                      <div class="form-group col-6">
                        <label>Monto potencial</label>
                        <input
                          type="number"
                          id="MaxSumLoc"
                          pattern="[0-9]"
                          title="Numbers only"
                          class="form-control"
                          [(ngModel)]="nuevaEtapa.MaxSumLoc"
                        />
                      </div>

                      <div class="form-group col-4">
                        <label style="display: flex;">Comentarios <div style="padding-left: 5px;color: #ff4242;">* Campo obligatorio</div> </label>
                        <input
                          type="text"
                          id="Memo"
                          value=""
                          class="form-control"
                          [(ngModel)]="nuevaEtapa.Memo"
                        />
                      </div>
                      <div class="col-4">
                        <label for="TipoDocAso">Tipo de documento</label>
                        <select
                          id="TipoDocAso"
                          class="form-control"
                          [(ngModel)]="nuevaEtapa.ObjType"
                          (change)="seleccionarDocumento()"
                        >
                          <option value="-1" disabled>Seleccionar Tipo de </option>
                          <option value="17">Orden de venta</option>
                          <option value="23">Cotización</option>
                        </select>
                      </div>

                      <div class="col-4">
                        <label>N° Documento</label>
                        <i class="fa-solid fa-eye" *ngIf="nuevaEtapa.DocId && nuevaEtapa.ObjType != '-1'" style="margin-left: 5px;color: #91CA41;cursor: pointer;" (click)="abrirOjo(nuevaEtapa)"></i>
                        <input
                          type="text"
                          class="form-control"
                          (click)="seleccionarDocumento()"
                          [(ngModel)]="nuevaEtapa.DocId"
                        />
                      </div>
                    </div>
                    <br />
                    <div class="form-group col-12">
                      <button
                        class="btn btn-secondary"
                        id="SendLINE"
                        (click)="enviarLinea()"
                      >
                        Agregar fila
                      </button>
                    </div>
                  </div>

                    <div class="row" style="overflow: auto;">
                      <table
                        class="table table-striped table-bordered"
                        id="TablaEtapas"
                        style="width: 100%"
                      >
                        <tbody>
                          <tr>
                            <th>#</th>
                            <th style="width: 200px">Fecha inicio</th>
                            <th style="width: 200px">Fecha cierre</th>
                            <th>Etapa</th>
                            <th>Monto potencial</th>
                            <th>Importe ponderado</th>
                            <th>Comentarios</th>
                            <th>Tipo de documento</th>
                            <th>Nº documento</th>
                          </tr>

                          <tr *ngFor="let item of this.data.OPR1;let i = index">
                            <td style="color: white;">{{ i + 1}}</td>
                            <td style="color: white;">{{item.OpenDate | date: 'dd/MM/yyyy'}}</td>
                            <td style="color: white;">{{item.CloseDate | date: 'dd/MM/yyyy'}}</td>

                            <td>
                              <div *ngFor="let etapa of Etapas">
                                <div *ngIf="etapa.StepId == item.Step_Id">
                                  <p style="color: white;">{{etapa.Descript}}</p>
                                </div>
                              </div>
                            </td>

                            <td style="color: white;">{{item.MaxSumLoc | iNDCLP}}</td>
                            <td style="color: white;">{{item.WtSumLoc | iNDCLP}}</td>
                            <td style="color: white;">{{item.Memo}}</td>
                            <td>
                              <div *ngIf="item.ObjType == '-1'" style="color: white;">Sin Tipo</div>
                              <div *ngIf="item.ObjType == '17'" style="color: white;">Orden de Venta</div>
                              <div *ngIf="item.ObjType == '23'" style="color: white;">Cotización</div>
                            </td>
                            <td>
                              <div *ngIf="item.DocId" (click)="abrirOjo(item)" style="color: #91CA41;cursor: pointer;">
                                <p style="color: white;">{{item.DocNumber}}</p>
                              </div>
                              <div *ngIf="!item.DocId">
                                <p style="color: white;">Sin N° Doc</p>
                              </div>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>



                  <div
                    class="tab-pane fade"
                    id="INT_historico"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-profile-tab"
                  >
                    <div class="post">
                      <div class="user-block" *ngFor="let item of Actividades">
                        <i class="fa-regular fa-user"></i>
                        <p>{{item.Notes}}</p>

                        <span class="description"
                          >{{item.Usuario}} - {{item.CreateDate | date: 'dd/MM/yyyy'}}</span
                        >
                      </div>

                    </div>


                  </div>

                  <div
                    class="tab-pane fade"
                    id="LOG_SAP"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-settings-tab"
                  >
                  <div class="post">
                    <div class="user-block">
                      <i class="fa-regular fa-user"></i>
                      <p>{{data.Name}}</p>
                      <span class="username">
                        <a href="############"></a>
                      </span>
                      <p></p>
                      <span class="description"
                        >{{data.CardName}} - {{data.UpdateDate | date: 'dd/MM/yyyy'}}</span
                      >
                    </div>
                    <!-- /.user-block -->
                    <p>Actualización de etapa.</p>
                  </div>

                    <a
                      class="btn btn-outline-success"
                      href="/Oportunidad/DescargaOportunidad?Tipo='SAP'"
                      target="_blank"
                      >Exportar</a
                    >
                  </div>

                  <div
                    class="tab-pane fade"
                    id="resumen"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-settings-tab"
                  >
                    <div class="form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          name="optradio"
                          checked=""
                          value="O"
                          [(ngModel)]="data.Status"
                        />Abierta
                      </label>
                    </div>
                    <div class="form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="W"
                          name="optradio"
                          [(ngModel)]="data.Status"
                        />Ganada
                      </label>
                    </div>
                    <div class="form-check-inline disabled">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="L"
                          name="optradio"
                          [(ngModel)]="data.Status"
                        />Perdida
                      </label>
                    </div>

                    <div class="d-inline-block pull-right">
                      <button
                        class="btn btn-primary"
                        onclick="ActualizarEstado()"
                      >
                        Actualizar
                      </button>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="Items"
                    role="tabpanel"
                    aria-labelledby="custom-tabs-one-Items-tab"
                  >
                    <div class="row">
                      <div class="form-group col-sm-12">
                        <label for="ItemCode" class="control-label"
                          >Articulo</label
                        >
                        <select
                          id="ItemCode"
                          style="width: 100%"
                          onchange="AgregarCarro(this.value)"
                          data-select2-id="ItemCode"
                          tabindex="-1"
                          class="select2-hidden-accessible"
                          aria-hidden="true"
                        >
                          <option data-select2-id="4"></option></select
                        ><span
                          class="select2 select2-container select2-container--classic"
                          dir="ltr"
                          data-select2-id="3"
                          style="width: 100%"
                          ><span class="selection"
                            ><span
                              class="select2-selection select2-selection--single"
                              role="combobox"
                              aria-haspopup="true"
                              aria-expanded="false"
                              tabindex="0"
                              aria-disabled="false"
                              aria-labelledby="select2-ItemCode-container"
                              ><span
                                class="select2-selection__rendered"
                                id="select2-ItemCode-container"
                                role="textbox"
                                aria-readonly="true"
                                ><span class="select2-selection__placeholder"
                                  >Articulo</span
                                ></span
                              ><span
                                class="select2-selection__arrow"
                                role="presentation"
                                ><b role="presentation"></b></span></span></span
                          ><span
                            class="dropdown-wrapper"
                            aria-hidden="true"
                          ></span
                        ></span>
                      </div>
                    </div>
                    <div class="container">
                      <div
                        id="tblProductos_wrapper"
                        class="dataTables_wrapper no-footer"
                      >
                        <div class="dataTables_length" id="tblProductos_length">
                          <label
                            >Mostrar
                            <select
                              name="tblProductos_length"
                              aria-controls="tblProductos"
                              class=""
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                            registros</label
                          >
                        </div>
                        <div id="tblProductos_filter" class="dataTables_filter">
                          <label
                            >Buscar:<input
                              type="search"
                              class=""
                              placeholder=""
                              aria-controls="tblProductos"
                          /></label>
                        </div>
                        <div class="dataTables_scroll">
                          <div
                            class="dataTables_scrollHead"
                            style="
                              overflow: hidden;
                              position: relative;
                              border: 0px;
                              width: 100%;
                            "
                          >
                            <div
                              class="dataTables_scrollHeadInner"
                              style="
                                box-sizing: content-box;
                                width: 0px;
                                padding-right: 0px;
                              "
                            >
                              <table
                                class="table table-striped dataTable no-footer"
                                style="width: 0px; margin-left: 0px"
                                role="grid"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      class="sorting_disabled"
                                      rowspan="1"
                                      colspan="1"
                                      style="width: 0px"
                                    >
                                      Articulo
                                    </th>
                                    <th
                                      class="sorting_disabled"
                                      rowspan="1"
                                      colspan="1"
                                      style="width: 0px"
                                    >
                                      Descripción
                                    </th>
                                    <th
                                      class="sorting_disabled"
                                      rowspan="1"
                                      colspan="1"
                                      style="width: 0px"
                                    ></th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                          <div
                            class="dataTables_scrollBody"
                            style="
                              position: relative;
                              overflow: auto;
                              width: 100%;
                            "
                          >
                            <table
                              id="tblProductos"
                              class="table table-striped dataTable no-footer"
                              style="width: 100%"
                              role="grid"
                              aria-describedby="tblProductos_info"
                            >
                              <thead>
                                <tr role="row" style="height: 0px">
                                  <th
                                    class="sorting_disabled"
                                    rowspan="1"
                                    colspan="1"
                                    style="
                                      width: 0px;
                                      padding-top: 0px;
                                      padding-bottom: 0px;
                                      border-top-width: 0px;
                                      border-bottom-width: 0px;
                                      height: 0px;
                                    "
                                  >
                                    <div
                                      class="dataTables_sizing"
                                      style="height: 0px; overflow: hidden"
                                    >
                                      Articulo
                                    </div>
                                  </th>
                                  <th
                                    class="sorting_disabled"
                                    rowspan="1"
                                    colspan="1"
                                    style="
                                      width: 0px;
                                      padding-top: 0px;
                                      padding-bottom: 0px;
                                      border-top-width: 0px;
                                      border-bottom-width: 0px;
                                      height: 0px;
                                    "
                                  >
                                    <div
                                      class="dataTables_sizing"
                                      style="height: 0px; overflow: hidden"
                                    >
                                      Descripción
                                    </div>
                                  </th>
                                  <th
                                    class="sorting_disabled"
                                    rowspan="1"
                                    colspan="1"
                                    style="
                                      width: 0px;
                                      padding-top: 0px;
                                      padding-bottom: 0px;
                                      border-top-width: 0px;
                                      border-bottom-width: 0px;
                                      height: 0px;
                                    "
                                  >
                                    <div
                                      class="dataTables_sizing"
                                      style="height: 0px; overflow: hidden"
                                    ></div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr role="row" class="odd">

                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          class="dataTables_info"
                          id="tblProductos_info"
                          role="status"
                          aria-live="polite"
                        >
                          Mostrando registros del 1 al 1 de un total de 1
                          registros
                        </div>
                        <div
                          class="dataTables_paginate paging_simple_numbers"
                          id="tblProductos_paginate"
                        >
                          <a
                            class="paginate_button previous disabled"
                            aria-controls="tblProductos"
                            data-dt-idx="0"
                            tabindex="-1"
                            id="tblProductos_previous"
                            >Anterior</a
                          ><span
                            ><a
                              class="paginate_button current"
                              aria-controls="tblProductos"
                              data-dt-idx="1"
                              tabindex="0"
                              >1</a
                            ></span
                          ><a
                            class="paginate_button next disabled"
                            aria-controls="tblProductos"
                            data-dt-idx="2"
                            tabindex="-1"
                            id="tblProductos_next"
                            >Siguiente</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-4 order-1 order-md-2 card">
        <h3 class="text-primary" style="color: #91CA41 !important;">
          <i class="fas fa-money-bill"></i> {{data.Name}}
        </h3>
        <p class="text-muted">
          {{data.Memo}}
        </p>
        <div class="card card-primary">
          <div class="card-header" style="background-color: #91CA41;color: #3F474E;">
            <h3 class="card-title">Empresa</h3>
          </div>
          <div class="card-body">{{data.CardName}}</div>
          <ul class="list-group">

          </ul>
        </div>
        <div class="card card-primary collapsed-card">
          <div class="card-header" style="background-color: #91CA41;color: #3F474E;">
            <h3 class="card-title">Adjuntos</h3>
            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse"
              >
                <i class="fas fa-plus" style="color: #3F474E;"></i>
              </button>
            </div>
          </div>
          <ul class="list-unstyled card-body">
            <li class="list-group-item">
              <table style="width: 100%;">
                <thead>
                  <tr>
                    <th>NOMBRE</th>
                    <th>VER</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Archivos">
                    <td>{{item.FileName}}</td>
                    <td>
                      <button (click)="verAdjunto(item)">
                        <i class="fa-solid fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <input type="file" (change)="onFileSelected($event)" />

            </li>
          </ul>

        </div>

        <div class="card card-primary collapsed-card">
          <div class="card-header" style="background-color: #91CA41;color: #3F474E;">
            <h3 class="card-title">Totales</h3>

            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse"
              >
                <i class="fas fa-plus" style="color: #3F474E;"></i>
              </button>
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <ul class="list-group">
              <li class="list-group-item">
                <label class="control-label"> Fecha de cierre prevista</label>
                <br />

                {{data.PredDate | date:'dd/MM/yyyy'}}
              </li>
              <li class="list-group-item">
                <label class="control-label"> Monto potencial</label>
                <br />

                ${{data.MaxSumLoc}}
              </li>
              <li class="list-group-item">
                <label class="control-label"> Monto ponderado</label>
                <br />

                ${{data.WtSumLoc}}
              </li>
            </ul>
          </div>
          <!-- /.card-body -->
        </div>
        <div class="card card-primary collapsed-card">
          <div class="card-header" style="background-color: #91CA41;color: #3F474E;">
            <h3 class="card-title">Fechas clave</h3>

            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse"
              >
                <i class="fas fa-plus" style="color: #3F474E;"></i>
              </button>
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <ul class="list-group">
              <li class="list-group-item">
                <label class="control-label"> Fecha de cierre</label>
                <br />
                <p>{{data.CloseDate | date: 'dd/MM/yyyy'}}</p>
              </li>
              <li class="list-group-item">
                <label class="control-label"> Fecha de inicio</label>
                <br />
                <p>{{data.OpenDate | date: 'dd/MM/yyyy'}}</p>
              </li>
              <li class="list-group-item">
                <label class="control-label">
                  Fecha prevista cierre etapa</label
                >
                <br />
                <p>{{data.PredDate | date: 'dd/MM/yyyy'}}</p>
              </li>
            </ul>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </div>
    <!-- /.card-body -->
  </div>
</div>
